import { render, staticRenderFns } from "./wechatFriends_node_form.vue?vue&type=template&id=46339bd5&"
import script from "./wechatFriends_node_form.vue?vue&type=script&lang=js&"
export * from "./wechatFriends_node_form.vue?vue&type=script&lang=js&"
import style0 from "./wechatFriends_node_form.vue?vue&type=style&index=0&id=46339bd5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports